import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveTemporaryConnectionMutationVariables = Types.Exact<{
  uuid: Types.Scalars['ID']['input'];
}>;


export type RemoveTemporaryConnectionMutation = { __typename?: 'Mutation', removeTemporaryConnection: boolean };


export const RemoveTemporaryConnectionDocument = gql`
    mutation RemoveTemporaryConnection($uuid: ID!) {
  removeTemporaryConnection(uuid: $uuid)
}
    `;
export type RemoveTemporaryConnectionMutationFn = Apollo.MutationFunction<RemoveTemporaryConnectionMutation, RemoveTemporaryConnectionMutationVariables>;

/**
 * __useRemoveTemporaryConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveTemporaryConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTemporaryConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTemporaryConnectionMutation, { data, loading, error }] = useRemoveTemporaryConnectionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useRemoveTemporaryConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTemporaryConnectionMutation, RemoveTemporaryConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTemporaryConnectionMutation, RemoveTemporaryConnectionMutationVariables>(RemoveTemporaryConnectionDocument, options);
      }
export type RemoveTemporaryConnectionMutationHookResult = ReturnType<typeof useRemoveTemporaryConnectionMutation>;
export type RemoveTemporaryConnectionMutationResult = Apollo.MutationResult<RemoveTemporaryConnectionMutation>;
export type RemoveTemporaryConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveTemporaryConnectionMutation, RemoveTemporaryConnectionMutationVariables>;